import React from "react"
import {
    FaGithubSquare,
    FaEnvelope,
    FaCoffee,
} from "react-icons/fa"
import "./sidebar.css"

const SocialLinks = ({ contacts }) => {
    return (
        <div className="side-social-links">
            <a  target="_blank"  rel="noopener noreferrer" href="https://www.buymeacoffee.com/wHexPZL">
                <span>
                    <FaCoffee size={48} />
                </span>
            </a>
            <a href={contacts.github} rel="noopener noreferrer" target="_blank">
                <span title="GitHub">
                    <FaGithubSquare size={48} />
                </span>
            </a>
            <a href="mailto:lkh151515@gmail.com">
                <span title="Email">
                    <FaEnvelope size={48} />
                </span>
            </a>
        </div>
    )
}

export default SocialLinks